import React from 'react';
import './MenuItem.css';



const MenuItem = ({ item }) => {

  return (
    <div className="menu-item">

      <img src={item.image} alt={item.name} /> {/* Menu Item Image */}

      <div className="content">

        <div className="intro">
          <h4> {/* Item Name and Tags */}
            {item.name}
            {item.tags.map(tag => (
              <span key={tag}>{tag}</span> // Display each tag with a unique key
            ))}
          </h4>
          <span className="line"></span> {/* Decorative Line */}
          <h5 className="price">${item.price}</h5> {/* Item Price */}
        </div>

        <p>{item.description}</p> {/* Item Description */}

      </div>

    </div>
  );
};

export default MenuItem;